export { default } from './NewPaymentMeanPage.container';
